import React from 'react';
import { motion } from "framer-motion";
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { experiences } from '../constants';
import Footer from './Footer';


const Experience = () => {
  return (
    <div className='w-screen pt-16 overflow-x-hidden text-white bg-black experience' id='experience'>
      <motion.div 
        className='pt-12 sm:px-16'
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <motion.p 
          className='font-light'
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          MY JOURNEY SO FAR.
        </motion.p>
        <motion.h2 
          className='mt-2 text-4xl font-extrabold sm:text-5xl'
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Work Experience.
        </motion.h2>
      </motion.div>
      <VerticalTimeline className='mt-9'>
        {experiences.map((experience, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
          >
            <VerticalTimelineElement
              className="relative vertical-timeline-element--work"
              contentStyle={{ background: "#1d1836", color: "#fff", }}
              contentArrowStyle={{ borderRight: "7px solid  #232631" }}
              date={experience.duration}
              iconStyle={{ background: '#fff' }}
              icon={
                <a className='flex items-center justify-center w-full h-full' href={experience.url} target='_blank'>
                  <motion.img
                    src={experience.logo}
                    alt={experience.company}
                    className='w-[60%] h-[60%] object-contain'
                    whileHover={{ scale: 1.1, rotate: 5 }}
                    transition={{ duration: 0.3 }}
                  />
                </a>
              }
            >
              <div>
                <h3 className='text-white text-[24px] font-bold'>{experience.role}</h3>
                <p
                  className='text-secondary text-[16px] font-semibold'
                  style={{ margin: 0 }}
                >
                  {experience.company}
                </p>
              </div>

              <ul className='mt-5 ml-5 space-y-2 list-disc'>
                {experience.points.map((point, pointIndex) => (
                  <motion.li
                    key={`experience-point-${pointIndex}`}
                    className='text-white-100 text-[14px] pl-1 tracking-wider'
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: pointIndex * 0.1 }}
                  >
                    {point}
                  </motion.li>
                ))}
              </ul>
            </VerticalTimelineElement>
          </motion.div>
        ))}
      </VerticalTimeline>
      <Footer/>
    </div>
  )
}

export default Experience;